// extracted by css-extract-rspack-plugin
export default {"loadingSkeletonContainer":"FormElementLoading-module__loadingSkeletonContainer__rNSPLL2"};